import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Col, Collapse, Form, Input, Modal, Row } from "reactstrap"
import { createMultipleUsers, getRoles } from "services/users/calls"
import { CSVLink } from "react-csv"
import { getAllChannels } from "services/support/calls"
import toast from "components/Toast/Toast"
import DataList from "components/DataList"

const csv = require("csvtojson")

const template = [
  ["name", "login", "documentId", "email"],
  ["Fulano", "fulano.beltrano", "1234567890", "john.doe@xyz.com"],
  ["Ciclano", "ciclano.beltrano", "9876543210", "ciclano@xyz.com"],
]

const columns = [
  {
    dataField: "name",
    text: "Nome",
    required: true,
  },
  {
    dataField: "login",
    text: "Login",
    required: true,
  },
  {
    dataField: "email",
    text: "E-mail",
  },
  {
    dataField: "documentId",
    text: "Documento",
  },
]

const NewMultiUser = props => {
  const [isLoading, handleLoading] = useState(true)
  const [roles, setRoles] = useState([])
  const [role, setRole] = useState(null)
  // const [channel, setChannel] = useState(null)
  const [list, setList] = useState([])
  const [fileError, setFileError] = useState(false)
  const [errors, setErrors] = useState({
    roleId: {
      required: null,
    },
    // channelId: {
    //   required: null,
    // },

    list: {
      list: null,
    },
  })
  const [newPassword, setNewPassword] = useState(null)
  const [created, setCreated] = useState(null)
  const [rejected, setRejected] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  // const [channels, setChannels] = useState([])

  let alertDialogRef

  const fetchRoles = async () => {
    try {
      const res = await getRoles()
      const { roles } = res.payload
      setRoles(roles)
    } catch (err) {
    } finally {
      handleLoading(false)
    }
  }

  // const fetchChannels = async () => {
  //   try {
  //     const canais = await getAllChannels()
  //     setChannels(canais)
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  useEffect(() => {
    // fetchChannels()
    fetchRoles()
  }, [])

  const [isOpenAccordion, handleAccordion] = useState(false)

  const toggleAccordion = () => {
    handleAccordion(!isOpenAccordion)
  }

  const validate = () => {
    const validations = {
      roleId: {
        required: !role || (role && !role.trim().length),
      },
      list: {
        list: list.length > 0 ? false : true,
      },
      // channelId: {
      //   required: !channel || (channel && !channel.trim().length),
      // },
    }
    setErrors(validations)
    return (
      !validations.roleId.required && !validations.list.list
      //  &&
      // !validations.channelId.required
    )
  }

  const validateFile = file => {
    setFileError(false)
    const filed = file.map(x => {
      columns.map(y => {
        if (y.required && x[y.dataField] === undefined) {
          x[y.dataField] = <div style={{ color: "red" }}>Faltando</div>
          setFileError(true)
        }
      })
      return x
    })
    return filed
  }

  const onCreateOrUpdate = async () => {
    try {
      if (!validate() || fileError) return
      handleLoading(true)
      const res = await createMultipleUsers(role, list)
      const {
        accesses: { password, rejected, created },
      } = res.payload
      setNewPassword(password)
      setRejected(rejected)
      setCreated(created)
      setModalOpen(true)
    } catch (error) {
      // const { response } = err
      // if (response) {
      //   const { data } = response
      //   const errors = data.errors.map(e => <p key={e.title}>{e.title}</p>)
      //   alertDialogRef.alert("Aviso", errors)
      //   return
      // }
      // alertDialogRef.alert("Aviso", "Occoreu um erro ao cadastrar usuário")
      console.error(error)
      toast("error", error?.message, error?.title)
    } finally {
      handleLoading(false)
    }
  }

  const handleChange = e => {
    const fileReader = new FileReader()
    fileReader.readAsText(e.target.files[0], "UTF-8")
    fileReader.onload = e => {
      csv()
        .fromString(e.target.result)
        .then(jsonObj => {
          setList(validateFile(jsonObj))
        })
    }
  }

  return (
    <React.Fragment>
      <Row>
        <p>Crie vários usuários para ter acesso ao sistema</p>
      </Row>
      <Row>
        <Form className="form-horizontal">
          <Row className="mb-1">
            <Col>
              <Row className="mb-3">
                <Col>
                  <Input
                    name="role"
                    className="form-control"
                    placeholder="Tipo de Acesso"
                    type="select"
                    onChange={e => {
                      setRole(e.target.value)
                    }}
                  >
                    <option value={""}>Tipo de Acesso</option>
                    {roles.map(role => (
                      <option value={role.id} key={`role-${role.id}`}>
                        {role.name}
                      </option>
                    ))}
                  </Input>
                </Col>
                {/* <Col>
                  <Input
                    name="channel"
                    className="form-control"
                    placeholder="Canal de Atendimento"
                    type="select"
                    onChange={e => {
                      setChannel(e.target.value)
                    }}
                  >
                    <option value={""}>Canal de Atendimento</option>
                    {channels.map(canal => (
                      <option value={canal.id} key={`canal-${canal.id}`}>
                        {canal.name}
                      </option>
                    ))}
                  </Input>
                </Col> */}
              </Row>
              <Row>
                <Col>
                  <Input
                    className="form-control"
                    type="file"
                    name="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={handleChange}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <div className="accordion" id="accordion">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button fw-medium"
                      type="button"
                      onClick={() => {
                        toggleAccordion()
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Mostrar Exemplo
                    </button>
                  </h2>
                </div>
                <Collapse
                  isOpen={isOpenAccordion}
                  className="accordion-collapse"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col>
                        O arquivo carregado deve estar no formato .csv, seguindo
                        o formato a baixo(
                        <CSVLink
                          filename={"templateUsuarios.csv"}
                          data={template}
                        >
                          Template
                        </CSVLink>
                        ):
                        <p>name,login,documentId,email</p>
                        <p>Fulano,fulano.beltrano,1234567891,email@email.com</p>
                      </Col>
                    </Row>
                  </div>
                </Collapse>
              </div>
            </Col>
          </Row>
          <div className="mt-3 d-grid">
            <button
              className="btn btn-primary btn-block"
              disabled={isLoading}
              onClick={e => {
                e.preventDefault()
                onCreateOrUpdate()
              }}
            >
              Cadastrar
            </button>
          </div>
        </Form>
      </Row>
      <Modal
        isOpen={modalOpen}
        toggle={() => {
          setModalOpen(!modalOpen)
        }}
        centered
        onClosed={() => {
          setNewPassword(null)
          setRejected(null)
          setCreated(null)
          props.setReRenderList(!props.reRenderList)
          props.setNav(0)
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>
              Usuários criados: {created?.length}. Anote o login e a senha dos
              usuários, esta senha so aparece uma vez.
            </p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setModalOpen(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Row>
            <Col>
              <b>{`A senha para os usuários é: ${newPassword}`}</b>
            </Col>
          </Row>
          <Row>
            <Col>
              {created?.length > 0 && (
                <DataList
                  infos={created.map(el => {
                    return { label: "Login", value: el?.login }
                  })}
                />
              )}
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setModalOpen(false)
            }}
            className="btn btn-secondary "
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

NewMultiUser.propTypes = {
  t: PropTypes.any,
  reRenderList: PropTypes.bool,
  setReRenderList: PropTypes.func,
  setNav: PropTypes.func,
}

export default withTranslation()(NewMultiUser)
